<template>
  <div id="users_detail">
    <Navbar
      current="Detalhes do psicólogo"
      :link="$paths.psychologists.list"
      :linkName="'Psicólogos'"
    />
    <Sidebar />
    <Container col="12">
      <Header title="Detalhes do Psi" v-if="!loadingItems">
        <template v-slot:button>
          <button
            v-if="item.deleted_at"
            @click="showReactivateModal = true"
            class="btn btn-success"
          >
            <i class="fa-solid fa-rotate-left"></i> Reativar conta
          </button>
          <div v-if="!item.deleted_at" class="d-inline-flex align-items-center gap-2">
            <div class="dropdown">
              <button
                class="btn btn-primary lift dropdown-toggle"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i class="fa-solid fa-bolt me-1"></i> Ações
              </button>
              <ul class="dropdown-menu dropdown-menu-end actions-dropdown">
                <li>
                  <router-link
                    class="dropdown-item"
                    :to="`${$paths.psychologists.edit}/${item.id}`"
                  >
                    <i class="fa-solid fa-pen me-2 text-muted"></i> Editar cadastro
                  </router-link>
                </li>
                <li>
                  <button class="dropdown-item" @click="changeCRPPhotosClicked()">
                    <i class="fa-solid fa-id-card me-2 text-muted"></i> Editar fotos CRP
                  </button>
                </li>
                <li>
                  <button class="dropdown-item" @click="showResetPasswordModal = true">
                    <i class="fa-solid fa-key me-2 text-muted"></i> Gerar link de senha
                  </button>
                </li>
                <li><hr class="dropdown-divider" /></li>
                <li>
                  <button class="dropdown-item" @click="handleChangeApprove()">
                    <i
                      class="me-2 text-muted"
                      :class="item.approved ? 'fa-solid fa-ban' : 'fa-solid fa-circle-check'"
                    ></i>
                    {{ item.approved ? "Desaprovar" : "Aprovar" }}
                  </button>
                </li>
                <li>
                  <button class="dropdown-item" @click="handleChangeActive()">
                    <i
                      class="me-2 text-muted"
                      :class="item.active ? 'fa-solid fa-lock' : 'fa-solid fa-lock-open'"
                    ></i>
                    {{ item.active ? "Desativar" : "Ativar" }}
                  </button>
                </li>
                <li>
                  <button class="dropdown-item" @click="handleChangeAgenda()">
                    <i
                      class="me-2 text-muted"
                      :class="!item?.block_agenda ? 'fa-solid fa-calendar-xmark' : 'fa-solid fa-calendar-check'"
                    ></i>
                    {{ !item?.block_agenda ? "Bloquear agenda" : "Desbloquear agenda" }}
                  </button>
                </li>
                <li><hr class="dropdown-divider" /></li>
                <li>
                  <button class="dropdown-item" @click="openCortesia()">
                    <i class="fa-solid fa-gift me-2 text-muted"></i> Dar Psiapp+ de cortesia
                  </button>
                </li>
                <li>
                  <button class="dropdown-item" @click="openNewBankAccount()">
                    <i class="fa-solid fa-building-columns me-2 text-muted"></i> Nova conta bancária
                  </button>
                </li>
                <li>
                  <button class="dropdown-item" @click="openResetStripe()">
                    <i class="fa-solid fa-rotate-left me-2 text-muted"></i> Resetar conta Stripe
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </template>
      </Header>

      <LoadingContainer v-if="loadingItems" />

      <div v-else>
        <div class="row">
          <div :class="showSummary ? 'col-12 col-xl-8' : 'col-12'">
            <div class="card">
              <!-- Nível 1: grupos -->
              <div class="d-flex align-items-center">
                <ul class="nav nav-tabs main-tabs ps-4 pt-3 flex-grow-1" role="tablist">
                  <li
                    v-for="group in tabGroups"
                    :key="group.id"
                    class="nav-item"
                    role="presentation"
                  >
                    <button
                      type="button"
                      class="nav-link"
                      :class="{ active: activeGroupId === group.id }"
                      @click="selectGroup(group)"
                    >
                      <i :class="group.icon" class="me-1"></i>
                      {{ group.label }}
                    </button>
                  </li>
                </ul>
              </div>
              <!-- Nível 2: sub-abas do grupo ativo -->
              <div class="subtabs-bar px-4 py-2">
                <button
                  v-for="tab in activeGroupTabs"
                  :key="tab.id"
                  type="button"
                  class="btn btn-sm subtab-pill"
                  :class="activeTab === tab.id ? 'active' : ''"
                  @click="selectTab(tab.id)"
                >
                  {{ tab.label }}
                  <span
                    v-if="tabBadge(tab.id)"
                    class="badge bg-primary-soft ms-1"
                    style="font-size: 0.75rem"
                    >{{ tabBadge(tab.id) }}</span
                  >
                </button>
              </div>
              <div class="tab-content" id="myTabContent">
                <!-- Account Tab -->
                <div
                  class="tab-pane card-body fade"
                  :class="{ 'show active': activeTab === 'account' }"
                  id="account"
                  role="tabpanel"
                >
                  <div
                    v-if="!item.deleted_at"
                    class="d-flex justify-content-end gap-2 mb-3"
                  >
                    <button
                      @click="handleChangeApprove()"
                      class="btn btn-sm"
                      :class="item.approved ? 'btn-outline-danger' : 'btn-success'"
                    >
                      <span
                        v-if="isApproving"
                        class="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      <i
                        v-else
                        :class="item.approved ? 'fa-solid fa-ban' : 'fa-solid fa-circle-check'"
                      ></i>
                      {{ item.approved ? "Desaprovar" : "Aprovar" }}
                    </button>
                    <button
                      @click="handleChangeActive()"
                      class="btn btn-sm btn-outline-secondary"
                    >
                      <i
                        :class="item.active ? 'fa-solid fa-lock' : 'fa-solid fa-lock-open'"
                      ></i>
                      {{ item.active ? "Desativar" : "Ativar" }}
                    </button>
                  </div>
                  <PsiDetailRegisterInfo
                    :item="item"
                    section="situacao"
                    @changeCallProvider="changeCallProvider"
                  />
                </div>

                <!-- Dados e perfil -->
                <div
                  class="tab-pane card-body fade"
                  :class="{ 'show active': activeTab === 'account-data' }"
                  id="account-data"
                  role="tabpanel"
                >
                  <div
                    v-if="!item.deleted_at"
                    class="d-flex justify-content-end gap-2 mb-3"
                  >
                    <button
                      @click="showResetPasswordModal = true"
                      class="btn btn-sm btn-outline-secondary"
                    >
                      <i class="fa-solid fa-key me-1"></i> Gerar link de senha
                    </button>
                    <router-link
                      :to="`${$paths.psychologists.edit}/${item.id}`"
                      class="btn btn-sm btn-outline-secondary"
                    >
                      <i class="fa-solid fa-pen me-1"></i> Editar cadastro
                    </router-link>
                  </div>
                  <PsiDetailRegisterInfo :item="item" section="dados" />
                  <hr class="my-4" />
                  <h2 class="fw-bold mb-4">Informações profissionais</h2>
                  <PsiDetailProfile :item="item" />
                </div>

                <!-- Documentos -->
                <div
                  class="tab-pane card-body fade"
                  :class="{ 'show active': activeTab === 'account-docs' }"
                  id="account-docs"
                  role="tabpanel"
                >
                  <div
                    v-if="!item.deleted_at"
                    class="d-flex justify-content-end mb-3"
                  >
                    <button
                      class="btn btn-sm btn-outline-secondary"
                      @click="changeCRPPhotosClicked()"
                    >
                      <i class="fa-solid fa-id-card me-1"></i> Editar fotos CRP
                    </button>
                  </div>
                  <PsiDetailRegisterInfo :item="item" section="documentos" />
                </div>

                <!-- Schedule Tab -->
                <div
                  class="tab-pane fade"
                  :class="{ 'show active': activeTab === 'schedule' }"
                  id="schedule"
                  role="tabpanel"
                >
                  <PsiDetailSchedules :item="item" />
                </div>

                <!-- Bank Tab -->
                <div
                  class="tab-pane card-body fade"
                  :class="{ 'show active': activeTab === 'bank' }"
                  id="bank"
                  role="tabpanel"
                >
                  <PsiDetailBankInfo :item="item" @accountCreated="getData" />
                </div>

                <!-- Appointments Tab -->
                <div
                  class="tab-pane fade"
                  :class="{ 'show active': activeTab === 'appointments' }"
                  id="appointments"
                  role="tabpanel"
                >
                  <div
                    v-if="!item.deleted_at"
                    class="d-flex justify-content-end p-3 pb-0"
                  >
                    <button
                      @click="handleChangeAgenda()"
                      class="btn btn-sm btn-outline-secondary"
                    >
                      <i
                        :class="!item.block_agenda ? 'fa-solid fa-calendar-xmark' : 'fa-solid fa-calendar-check'"
                        class="me-1"
                      ></i>
                      {{ !item.block_agenda ? "Bloquear agenda" : "Desbloquear agenda" }}
                    </button>
                  </div>
                  <PsiDetailAppointments
                    v-if="appointmentsLoaded"
                    :item="item"
                    ref="appointmentsComponent"
                  />
                </div>

                <!-- Transfer Tab -->
                <div
                  class="tab-pane fade"
                  :class="{ 'show active': activeTab === 'transfer' }"
                  id="transfer"
                  role="tabpanel"
                >
                  <PsiDetailPayouts :item="item" />
                </div>

                <!-- Review Tab -->
                <div
                  class="tab-pane card-body fade"
                  :class="{ 'show active': activeTab === 'review' }"
                  id="review"
                  role="tabpanel"
                >
                  <PsiDetailRatings :item="item" />
                </div>

                <!-- Coupons Tab -->
                <div
                  class="tab-pane card-body fade"
                  :class="{ 'show active': activeTab === 'coupons' }"
                  id="coupons"
                  role="tabpanel"
                >
                  <PsiDetailCoupons :item="item" />
                </div>

                <!-- Subscriptions Tab -->
                <div
                  class="tab-pane fade"
                  :class="{ 'show active': activeTab === 'subscriptions' }"
                  id="subscriptions"
                  role="tabpanel"
                >
                  <PsiDetailSubscriptions :item="item" @refresh="getData" />
                </div>

                <!-- Connect Accounts Tab -->
                <div
                  class="tab-pane fade"
                  :class="{ 'show active': activeTab === 'connect-accounts' }"
                  id="connect-accounts"
                  role="tabpanel"
                >
                  <PsiDetailConnectAccounts
                    v-if="connectAccountsLoaded"
                    :item="item"
                    ref="connectAccountsComponent"
                  />
                </div>

                <!-- Recurrencies Tab -->
                <div
                  class="tab-pane card-body fade"
                  :class="{ 'show active': activeTab === 'recurrencies' }"
                  id="recurrencies"
                  role="tabpanel"
                >
                  <PsiDetailRecurrencies :item="item" @refresh="getData" />
                </div>

                <!-- Change Logs Tab -->
                <div
                  class="tab-pane card-body fade"
                  :class="{ 'show active': activeTab === 'change-logs' }"
                  id="change-logs"
                  role="tabpanel"
                >
                  <UserChangeLogsTab
                    v-if="changeLogsLoaded"
                    :userId="item.id"
                  />
                </div>

                <!-- Admin Logs Tab -->
                <div
                  class="tab-pane card-body fade"
                  :class="{ 'show active': activeTab === 'admin-logs' }"
                  id="admin-logs"
                  role="tabpanel"
                >
                  <AdminActionLogsList
                    v-if="adminLogsLoaded"
                    :baseFilters="{ target_type: 'psychologist', target_id: item.id }"
                    :hideTargetFilter="true"
                  />
                </div>
              </div>
            </div>
          </div>
          <!-- STICKY CARD -->
          <transition name="slide-panel">
            <div class="col-12 col-xl-4" v-show="showSummary">
              <PsiDetailSummary :item="item" @hide="showSummary = false" />
            </div>
          </transition>
        </div>
      </div>
    </Container>
    <ModalComponent :title="'Alterar email'" id="changeEmailModal">
      <template v-slot:body>
        <div class="mt-3">
          <TextInput
            label=""
            :model="$v.form.email"
            class="text-white"
            placeholder="Confirme a senha"
          />
          <p v-if="$v.form.email.$invalid" class="text-danger">
            * Email inválido
          </p>
          <p class="text-center text-danger">
            {{ errorMessage }}
          </p>
        </div>
      </template>
      <template v-slot:footer>
        <div>
          <FormButton
            label="Concluir"
            :loading="submitting"
            :disabled="$v.form.$invalid"
            class="btn w-15 btn-primary mb-3"
            @onClick="handleChangeEmail"
          />
        </div>
      </template>
    </ModalComponent>

    <ModalComponent :title="'Alterar fotos do CRP'" id="changeCRPPhotosModal">
      <template v-slot:body>
        <div class="mt-3">
          <label class="text-muted mb-3 mt-3 form-label"
            >Foto do CRP <i class="text-danger">*</i></label
          >
          <input
            type="file"
            class="form-control"
            accept="image/*,application/pdf"
            @change="handleDocumentImageChange"
          />
          <div v-if="documentImagePreview" class="mt-3">
            <iframe
              v-if="documentImagePreview.isPdf"
              :src="documentImagePreview.url"
              class="w-100 border rounded"
              style="height: 300px"
            ></iframe>
            <img
              v-else
              :src="documentImagePreview.url"
              class="img-fluid rounded border"
              style="max-height: 300px"
            />
          </div>
          <p
            v-if="$v.changeCRPPhotosForm.document_image.$invalid"
            class="text-danger mt-2"
          >
            * Selecione uma foto ou PDF do CRP
          </p>

          <label class="text-muted mb-3 mt-4 form-label"
            >Foto psi segurando o CRP <i class="text-danger">*</i></label
          >
          <input
            type="file"
            class="form-control"
            accept="image/*,application/pdf"
            @change="handleDocumentInHandChange"
          />
          <div v-if="documentInHandPreview" class="mt-3">
            <iframe
              v-if="documentInHandPreview.isPdf"
              :src="documentInHandPreview.url"
              class="w-100 border rounded"
              style="height: 300px"
            ></iframe>
            <img
              v-else
              :src="documentInHandPreview.url"
              class="img-fluid rounded border"
              style="max-height: 300px"
            />
          </div>
          <p
            v-if="$v.changeCRPPhotosForm.document_in_hand.$invalid"
            class="text-danger mt-2"
          >
            * Selecione uma foto ou PDF do psi segurando CRP
          </p>
        </div>
      </template>
      <template v-slot:footer>
        <div>
          <FormButton
            label="Concluir alteração"
            :loading="submitting"
            :disabled="$v.$invalid"
            class="btn w-15 btn-primary mb-3"
            @onClick="handlechangeCRPPhotos"
          />
        </div>
      </template>
    </ModalComponent>

    <!-- Modal Reativar Conta -->
    <div
      class="modal fade"
      :class="{ show: showReactivateModal }"
      :style="{ display: showReactivateModal ? 'block' : 'none' }"
      tabindex="-1"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              <i class="fa-solid fa-rotate-left me-2"></i>
              Reativar conta excluída
            </h5>
            <button type="button" class="btn-close" @click="closeReactivateModal"></button>
          </div>
          <div class="modal-body">
            <div class="alert alert-warning">
              <strong>Atenção!</strong> Esta conta foi excluída anteriormente.
            </div>
            <p>Ao reativar esta conta, o usuário poderá acessar o aplicativo novamente com as mesmas credenciais.</p>
            <div class="form-check mt-4">
              <input
                class="form-check-input"
                type="checkbox"
                id="confirmReactivateCheckbox"
                v-model="confirmReactivate"
              />
              <label class="form-check-label" for="confirmReactivateCheckbox">
                <strong>Eu confirmo</strong> que desejo reativar esta conta
              </label>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeReactivateModal">Cancelar</button>
            <button
              type="button"
              class="btn btn-success"
              :disabled="!confirmReactivate || reactivating"
              @click="handleReactivateAccount"
            >
              <span v-if="reactivating" class="spinner-border spinner-border-sm me-1"></span>
              Reativar conta
            </button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="showReactivateModal" class="modal-backdrop fade show"></div>

    <!-- Modal Gerar Link Reset Senha -->
    <div
      class="modal fade"
      :class="{ show: showResetPasswordModal }"
      :style="{ display: showResetPasswordModal ? 'block' : 'none' }"
      tabindex="-1"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              <i class="fa-solid fa-key me-2"></i>
              Gerar link de redefinição de senha
            </h5>
            <button type="button" class="btn-close" @click="closeResetPasswordModal"></button>
          </div>
          <div class="modal-body">
            <div v-if="!resetPasswordLink">
              <p>Será gerado um link para o usuário redefinir sua senha. Você poderá copiar e enviar para ele.</p>
              <button
                class="btn btn-primary w-100"
                :disabled="generatingResetLink"
                @click="handleGenerateResetLink"
              >
                <span v-if="generatingResetLink" class="spinner-border spinner-border-sm me-1"></span>
                Gerar link
              </button>
            </div>
            <div v-else>
              <div class="alert alert-success">
                <i class="fa-solid fa-check-circle me-1"></i>
                Link gerado com sucesso!
              </div>
              <label class="form-label text-muted">Link de redefinição:</label>
              <div class="input-group">
                <input
                  type="text"
                  class="form-control"
                  :value="resetPasswordLink"
                  readonly
                />
                <button class="btn btn-outline-secondary" @click="copyResetLink">
                  <i class="fa-solid fa-copy"></i>
                </button>
              </div>
              <small class="text-muted">Copie e envie este link para o usuário</small>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeResetPasswordModal">Fechar</button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="showResetPasswordModal" class="modal-backdrop fade show"></div>
  </div>
</template>
<script>
import PsychologistDetailController from "./PsychologistDetailController";
export default PsychologistDetailController;
</script>
<style scoped>
.slide-panel-enter-active,
.slide-panel-leave-active {
  transition: opacity 0.3s ease, transform 0.3s ease;
  overflow: hidden;
}
.slide-panel-enter,
.slide-panel-leave-to {
  opacity: 0;
  transform: translateX(30px);
}

/* Menu "Mais ações" acima do painel lateral sticky (z-index 1020) */
.actions-dropdown {
  z-index: 1055;
}

/* Abas principais (nível 1) — sem o tracinho laranja, conecta à barra de sub-abas */
.main-tabs .nav-link {
  padding-left: 14px;
  padding-right: 14px;
  border-radius: 8px 8px 0 0;
  border-bottom-color: transparent !important;
}

.main-tabs .nav-link.active {
  color: #212529;
  font-weight: 600;
  background-color: #f8f9fa;
}

/* Barra de sub-abas (nível 2) */
.subtabs-bar {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  background-color: #f8f9fa;
  border-bottom: 1px solid #e9ecef;
}

.subtab-pill {
  border: 1px solid transparent;
  background-color: transparent;
  color: #6c757d;
  font-weight: 500;
  border-radius: 6px;
  padding: 4px 14px;
  transition: all 0.15s;
}

.subtab-pill:hover {
  background-color: #eceef1;
  color: #495057;
}

.subtab-pill.active {
  background-color: #fff;
  color: #212529;
  font-weight: 600;
  border-color: #dee2e6;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}
</style>
